// @flow

import React from 'react';
import {getRowData} from './utils';

import type {StatelessFunctionalComponent} from 'react';

/**
 * Foot component Props
 */
type FootProps = {|
    children: React$Node,
    /**
     * Custom foot height
     */
    height?: number,
|};

export const Foot: StatelessFunctionalComponent<FootProps> = props => {
    const {children, wrappedCells} = getRowData({
        children: props.children,
        height: props.height
    });
    return (
        <tfoot>
            {children}
            {wrappedCells}
        </tfoot>
    );
};
